import { render, staticRenderFns } from "./PropertyBoxStyle.vue?vue&type=template&id=e4e625e8&scoped=true&"
import script from "./PropertyBoxStyle.vue?vue&type=script&lang=js&"
export * from "./PropertyBoxStyle.vue?vue&type=script&lang=js&"
import style0 from "./PropertyBoxStyle.vue?vue&type=style&index=0&id=e4e625e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e625e8",
  null
  
)

export default component.exports